import React from 'react';

import { IconFont } from 'fr-shared/components';

type PriceRangeWarningProps = {
  variant: 'below' | 'above';
};

const MESSAGES = {
  below:
    'The overall order value based on a combination of manufacturing technology and quantity ' +
    'is creating an order price less than $1,000. To ensure we can cover our costs we have a ' +
    'minimum order value of $1,000. If you wish to continue to order please select a production ' +
    'quantity that will create an order value of at least $1,000, then hit "Next"',
  above:
    'The overall order value based on a combination of manufacturing technology and quantity ' +
    'is creating an order price greater than $20,000. To make sure that we have this right for ' +
    'you, we would like to take a deeper look with our team. To continue and have us do a quick ' +
    'review please click "Next" and then hit "Request Quote" on the following screen.',
};

const PriceRangeWarning = ({ variant }: PriceRangeWarningProps) => {
  return (
    <div
      className="max-w-[522px] bg-coolGray-700 border border-coolGray-600 rounded-[8px] py-2 px-3 flex ml-3"
      data-testid="price-range-warning"
    >
      <div className="flex flex-column mr-2 mt-1">
        <div className="text-coolGray-300 text-xs">{MESSAGES[variant]}</div>
      </div>
      <IconFont
        name="error-triangle"
        className="flex flex-column justify-start text-coolGray-100 text-[40px]"
      />
    </div>
  );
};

export default PriceRangeWarning;
